import { Address, AddressFormData } from './Address'

export const getAddressFormDataDivergence = (formData: AddressFormData, address: Address): boolean => (
    formData.city !== address.city
        || formData.houseNumber !== address.houseNumber
        || formData.houseNumberAddition !== address.houseNumberAddition
        || formData.postalCode !== address.postalCode
        || formData.street !== address.street
)
